import defined from '~app/core/defined';

export default async function(imageUrl) {
  return new Promise(resolve => {
    if (defined(imageUrl)) {
      const imgTag = new Image();

      // Create a completion handler.
      imgTag.onload = () => {
        resolve();
      };

      // Kick off the load.
      imgTag.src = imageUrl;
    }
    else {
      resolve();
    }
  });
}



// WEBPACK FOOTER //
// ./src/core/preloadImage.js